import { Box, IconProps, Typography } from "@mui/material"
import { useStyles } from "./styles"
import { LeftProps } from "./type"
import StatusComponent from "../../../../../../components/status"
import { DetailTypeOfResponse } from "../../../../../../components/detailTypeOfResponse"
import TypeAndDescription from "../../components/typeAndDescription"
import ActionCard from "../../components/actionCard"
import { icons } from "../../../../../../utils/icons"
import dayjs from "dayjs"
import { Constants } from "../../../../../../utils/constants"
import { DetailKeyValue, SnackSimple } from "../../../../../../components"
import { Status, Types } from "../../../../../../utils/enums"
import { useTranslation } from "react-i18next"
import { getStatus } from "../../../../../../hooks/status"
import { useContextState } from "../../../../../../hooks/theme"
import { useCallback, useMemo, useState } from "react"
import { VariantCard } from "../../components/actionCard/enum"
import { downloadReportUrl } from "./methods"
import { useParams } from "react-router-dom"
import { SnackbarFormat } from "../../../../../../utils/types/generals"

function Left({
    status,
    title,
    userAssigned,
    cancelLoading,
    answerList,
    reportUrl,
    question,
    answerType,
    showQuestionAndAnswers,
    creator,
    store,
    showCancelActionPlan,
    actionPlan,
    answer,
    endDate,
    blockquestionnaireData,
    cancelActionPlan,
    fullAnswer
}: LeftProps) {
    const { id } = useParams()
    const { t } = useTranslation()
    const { colors } = useContextState()
    const styles = useStyles()
    const [snackbar, setSnackbar] = useState<SnackbarFormat>()
    const [isDownloading, setIsDowloading] = useState(false)
    const finishStatus = getStatus(answer?.statusId as Status, colors, t)
    const variantStatus = useMemo(() => {
        if (status?.value == Status.REJECTED) return VariantCard.REJECT
        if (status?.value == Status.APPROVED) return VariantCard.ACTIVE
        return
    }, [status?.value])

    const downloadReport = useCallback(async () => {
        setIsDowloading(true)
        const { response } = await downloadReportUrl({ url: reportUrl, id })
        setIsDowloading(false)
        if (response) {
            setSnackbar({
                open: true,
                message: t('actionPlan.successDownloadReport'),
                type: Types.SUCCESS
            })
            return
        }
        setSnackbar({
            open: true,
            message: t('actionPlan.errorDownloadReport'),
            type: Types.ERROR
        })
    }, [reportUrl, id])

    const closeSnackbar = () => {
        setSnackbar(undefined)
    }
    return (
        <Box sx={styles.container} className="h-full">
            <Box className="flex gap-col-2 flex-wrap gap-row-1">
                <Typography className="break-w flex-1" variant="subtitle" fontWeight="bold">{actionPlan?.title ?? ''}</Typography>

                <Box className="flex-0"><StatusComponent size="small" fit color={status?.color ?? ''} msg={status?.text ?? ''} type="chip" /></Box>

                <Typography className="w-full" variant="footer" fontWeight="bold">{t('actionPlan.solutionDate', { date: endDate })}</Typography>
            </Box>

            <hr />

            {
                !blockquestionnaireData && (
                    <>
                        <DetailKeyValue sxContainer={styles.detailTitle} value={title} caption="Cuestionario" />

                        {!!showQuestionAndAnswers && (
                            <Box sx={{ ...styles.container, padding: 0 }}>
                                <TypeAndDescription
                                    description={question}
                                    title="Pregunta del cuestionario"
                                />

                                <DetailTypeOfResponse answersList={answerList || []} type={answerType} fullAnswer={fullAnswer} />
                            </Box>
                        )}
                    </>
                )
            }

            <ActionCard
                icon={{ position: 'start', icon: <ActionCard.Icon<IconProps> color='primary_company' icon={icons('person')} /> }}
            >
                <ActionCard.Header label={t('actionPlan.generatedBy')} />

                <ActionCard.Title label={creator.label} />

                <ActionCard.Footer label={dayjs(creator.date).locale('es').format(Constants.dayjsHumanFormat)} />
            </ActionCard>

            {
                !!userAssigned && (
                    <ActionCard
                        icon={{ position: 'start', icon: <ActionCard.Icon<IconProps> color='primary_company' icon={icons('person')} /> }}
                    >
                        <ActionCard.Header label={t('actionPlan.userSolver')} />

                        <ActionCard.Title label={userAssigned.label} />

                        {!!userAssigned.footer && <ActionCard.Footer label={`${t('general.tags.curp')}: ${userAssigned.footer}`} />}
                    </ActionCard>
                )
            }

            {
                !!store && (
                    <ActionCard
                        icon={{ position: 'start', icon: <ActionCard.Icon<IconProps> color='primary_company' icon={icons('store')} /> }}
                    >
                        <ActionCard.Header label={t('actionPlan.referencedStore')} />

                        <ActionCard.Title label={store?.label} />

                        <ActionCard.Footer label={store.footer ?? ''} />

                        <ActionCard.Footer label={t('general.timeZoneDetail', {timeZone: store?.timeZone})} />
                    </ActionCard>
                )
            }

            {
                [Status.REJECTED, Status.APPROVED].includes(status?.value as Status) && (
                    <ActionCard
                        variantCard={variantStatus}
                        icon={{ position: 'start', icon: <ActionCard.Icon<IconProps> color='primary_company' icon={icons('person')} /> }}
                    >
                        <ActionCard.Header label={Status.REJECTED == status?.value ? t(`actionPlan.rejectBy`) : t(`actionPlan.aproveBy`)} />

                        <ActionCard.Title label={`${answer?.userReview?.firstName ?? ''} ${answer?.userReview?.lastName ?? ''}`.trim()} />

                        <ActionCard.Footer label={dayjs(answer?.update_time).locale('es').format(Constants.dayjsHumanFormat)} />
                    </ActionCard>
                )
            }

            <ActionCard
                onClick={() => {
                    if (!isDownloading) {
                        downloadReport()
                    }
                }}
                hover={!isDownloading}
                icon={{ position: 'start', icon: <ActionCard.Icon<IconProps> sx={{ marginLeft: '4px' }} color='red' icon={icons('pdf')} /> }}
            >
                <ActionCard.SubTitle label={t('general.downloadReport')} />
            </ActionCard>

            {
                !!showCancelActionPlan && (
                    <ActionCard
                        onClick={() => {
                            if (!cancelLoading) {
                                cancelActionPlan()
                            }
                        }}
                        hover={!cancelLoading}
                        button
                        icon={{ position: 'start', icon: <ActionCard.Icon<IconProps> color='red' icon={icons('simple-close')} /> }}
                    >
                        <ActionCard.SubTitle color="c_red.main" label={t('general.cancelActionPlan')} />
                    </ActionCard>
                )
            }

            <SnackSimple close={closeSnackbar} open={snackbar?.open} type={snackbar?.type} message={snackbar?.message} />
        </Box >
    )
}

export default Left